import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    genresViewOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    genresViewInnerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      padding: '32px 64px 40px 64px',
      [theme.breakpoints.down('lg')]: {
        height: '1620px'
      }
    },
    genresCardContainer: {
      height: '461px',
      background: 'transparent',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'row',
      flex: '0 1 auto',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        height: 'fit-content',
        flex: '1',
        width: '100%'
      }
    },
    genresCardBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 16px 0px 16px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        margin: '20px 0',
        padding: '0px'
      }
    },
    genresCardContent: {
      flexDirection: 'column',
      width: '365px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        width: '755px',
        height: '250px'
      }
    },
    genresCardImage: {
      alignItems: 'center',
      justifyContent: 'center',
      height: '275px',
      overflow: 'hidden',
      background: 'transparent',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        width: '333px',
        height: '100%',
        alignItems: 'normal'
      }
    },
    genresDefaultImage: {
      height: '100%',
      objectFit: 'cover',
      [theme.breakpoints.down('lg')]: {
        width: 'auto'
      }
    },
    genresViewImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '8px 8px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        borderRadius: '8px 0px 0px 8px'
      }
    },
    genresHorizontalDivider: {
      marginTop: '-1px',
      padding: '0px 24px',
      background: 'transparent',
      maxHeight: '5px',
      display: 'block',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    genresVerticalDivider: {
      display: 'none',
      background: 'rgba(155,155,155)',
      height: '248px',
      width: '1px',
      [theme.breakpoints.down('lg')]: {
        display: 'block'
      }
    },
    genresCardText: {
      justifyContent: 'space-between',
      height: '185px',
      background: 'transparent',
      padding: '12px 24px',
      alignItems: 'stretch',
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'space-around',
        width: '420px',
        height: '100%'
      }
    }
  })
);
